import { _ } from "libs";
import React from "react";
import cx from "classnames";

const RewardItemMedium = ({ title, imageUrl, className }: { title: string; imageUrl: string; className?: string }) => {
	return (
		<div className={cx("item", "challengeReward", className)}>
			{imageUrl ? (
				<div className="itemImage" style={{ backgroundImage: `url(${imageUrl})` }} />
			) : (
				<div className="itemImage" />
			)}
			<div className="itemBody">
				<div className="label">{_("reward")}</div>
				<div className="title">{title}</div>
			</div>
		</div>
	);
};

export default RewardItemMedium;
